import type { ReactNode } from 'react';

export type Tab = 'submit' | 'board' | 'fixes' | 'more';

type Props = {
  active: Tab;
  onChange: (t: Tab) => void;
  fixesOpenCount: number;
  submitDone: boolean;
};

export function BottomNav({ active, onChange, fixesOpenCount, submitDone }: Props) {
  return (
    <nav className="bottom-nav" aria-label="Primary">
      <div className="bottom-nav-row">
        <Item
          label="Submit"
          icon={<Icon.Check done={submitDone} />}
          active={active === 'submit'}
          onClick={() => onChange('submit')}
        />
        <Item
          label="Board"
          icon={<Icon.Grid />}
          active={active === 'board'}
          onClick={() => onChange('board')}
        />
        <Item
          label="Fixes"
          icon={<Icon.Wrench />}
          active={active === 'fixes'}
          badge={fixesOpenCount > 0 ? fixesOpenCount : undefined}
          onClick={() => onChange('fixes')}
        />
        <Item
          label="More"
          icon={<Icon.Dots />}
          active={active === 'more'}
          onClick={() => onChange('more')}
        />
      </div>
    </nav>
  );
}

function Item({
  label, icon, active, badge, onClick,
}: {
  label: string; icon: ReactNode; active: boolean;
  badge?: number; onClick: () => void;
}) {
  return (
    <button
      className="bottom-nav-item relative"
      aria-current={active}
      onClick={onClick}
    >
      <div className="h-6 w-6 flex items-center justify-center">{icon}</div>
      <span>{label}</span>
      {badge !== undefined && (
        <span
          className="absolute top-1 right-[calc(50%-24px)] min-w-[18px] h-[18px]
                     px-1 flex items-center justify-center
                     text-[10px] font-heading bg-coast-blue text-coast-black"
        >
          {badge}
        </span>
      )}
    </button>
  );
}

const Icon = {
  Check({ done }: { done: boolean }) {
    return (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none"
           stroke={done ? '#53A0D8' : 'currentColor'} strokeWidth={2}>
        <rect x="4" y="4" width="16" height="16" />
        {done && <path d="M8 12 l3 3 l5 -6" />}
      </svg>
    );
  },
  Grid() {
    return (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={2}>
        <rect x="3" y="3" width="7" height="7" />
        <rect x="14" y="3" width="7" height="7" />
        <rect x="3" y="14" width="7" height="7" />
        <rect x="14" y="14" width="7" height="7" />
      </svg>
    );
  },
  Wrench() {
    return (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth={2}>
        <path d="M14 4a5 5 0 1 0 5 6l3 3-4 4-3-3a5 5 0 0 1-6-5" />
      </svg>
    );
  },
  Dots() {
    return (
      <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
        <circle cx="6" cy="12" r="1.6" />
        <circle cx="12" cy="12" r="1.6" />
        <circle cx="18" cy="12" r="1.6" />
      </svg>
    );
  },
};
